import { useNavigate } from "react-router-dom";
import { Button, Form, Input, message, Space, Card, Modal,Watermark } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";
import React, { useState, useEffect, useRef } from "react";

export const RegisterUser = () => {
  const navigate = useNavigate();
  const { registerUser, resendConfirmationEmail } = LayoutData();
  const [errorMessage, setErrorMessage] = useState();
  const [form] = Form.useForm();
  const [aktvalues] = useState({
    username: "",
    password: "",
    password2: "",
  });

  const onFinish = async (values) => {
    if (values.username && values.password)
      try {
        let response = await registerUser(values.username, values.password);
        switch (response) {
          case 200:
            message.success(
              <>
                "Registrierung erfolgreich - ein Email wurde an{" "}
                <b>{values.username}</b> gesendet"
              </>
            );
            navigate("/login");
            break;
          case 500:
            message.error("Interner Server Fehler");
            navigate("/home");
            break;
          default:
            //console.log("DuplicateEmail",response.errors.DuplicateEmail[0]);
            //console.log("DuplicateUserName",response.errors.DuplicateUserName[0]);
            const errorMessages = Object.values(
              response.errors.DuplicateEmail
            ).flatMap((errors) => errors);
            const errorMessage = errorMessages.join(", ");
            //console.log(errorMessage);
            setErrorMessage(errorMessage);
            message.error(
              <>
                Neuanmeldung nicht möglich: <b>{errorMessage}</b>
              </>
            );

            //navigate("/home");
            break;
        }
      } catch (error) {
        message.error(error);
        navigate("/login");
      }
  };
  const validatePassword = (rule, value, callback) => {
    if (
      !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+}{"':;?/>.<,])(?=.*[^\w\s]).{6,20}/.test(
        value
      )
    ) {
      callback(
        "Mindestens 1 Großbuchstabe, 1 Kleinbuchstabe, 1 Zahl, 1 Sonderzeichen erforderlich"
      );
    } else {
      callback();
    }
  };

  const ResendConfirmEMailButton = ({ username }) => {
    //const navigate = useNavigate();
    const handleForgotPasswordClick = () => {
      const handeEMailSenden = async (username) => {
        //navigate(`/forgot-password?username=${username}`);
        if (username)
          try {
            let response = await resendConfirmationEmail(username);
            switch (response) {
              case 200:
                message.success(
                  <>
                    Registrierungsbestätigung wurde an <b>{username}</b>{" "}
                    gesendet"
                  </>
                );
                setErrorMessage("Registrierungsbestätigung versendet");
                navigate("/login");
                break;
              case 500:
                message.error("Interner Server Fehler");
                navigate("/home");
                break;
              default:
                console.log("response", response);
                //console.log("DuplicateEmail",response.errors.DuplicateEmail[0]);
                //console.log("DuplicateUserName",response.errors.DuplicateUserName[0]);
                /*
            const errorMessages = Object.values(
              response.errors.DuplicateEmail
            ).flatMap((errors) => errors);
            const errorMessage = errorMessages.join(", ");
            //console.log(errorMessage);
            setErrorMessage(errorMessage);
            message.error(
              <>
                Neuanmeldung nicht möglich: <b>{errorMessage}</b>
              </>
            );
*/
                //navigate("/home");
                break;
            }
          } catch (error) {
            message.error(error);
            navigate("/");
          }
      };
      //console.log(form,form.getFieldValue("username"));
      setErrorMessage("");
      handeEMailSenden(form.getFieldValue("username"));
    };
    return (
      <Form.Item>
        <Button type="link" onClick={handleForgotPasswordClick}>
          Bestätigungsemail erneut senden?
        </Button>
      </Form.Item>
    );
  };

  return (
    <>
      <div className="page">
        <Watermark content="Neuanmeldung">

        <center>
          <Space direction="vertical" size={12}>
            <Card
              title={
                <>
                  Registrieren Sie sich mit EMail und Passwort
                  {errorMessage && (
                    <>
                      <br />
                      <small>
                        <div style={{ maxWidth: 300, color: "red" }}>
                          {errorMessage}
                        </div>
                      </small>
                    </>
                  )}
                </>
              }
              /*extra={<a href="#">More</a>} */ style={{
                maxWidth: 350,
                marginTop: 25,
              }}
            >
              <Form
                layout="vertical"
                initialValues={aktvalues}
                onFinish={onFinish}
                form={form}
              >
                <Form.Item
                  label="Username:"
                  name="username"
                  //     rules={userNameRules}
                  rules={[
                    {
                      type: "email",
                      message:
                        "Bitte geben Sie eine gültige E-Mail-Adresse ein!",
                    },
                    {
                      required: true,
                      message: "Bitte geben Sie Ihren Benutzernamen als EMail!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Benutzername als EMail"
                    required
                    prefix={<UserOutlined />}
                  ></Input>
                </Form.Item>
                <Form.Item
                  label="Passwort:"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Geben Sie ein starkes Passwort ein",
                    },
                    {
                      min: 6,
                      message: "Mindestens 6 Zeichen",
                    },
                    {
                      validator: validatePassword,
                    },
                  ]}
                  validateTrigger="onChange" // Validierung während der Eingabe auslösen
                >
                  <Input
                    type="password"
                    placeholder="Passwort"
                    required
                    prefix={<LockOutlined />}
                    allowClear={false}
                    disabled={false}
                  ></Input>
                </Form.Item>
                <Form.Item
                  label="Passwort bestätigen:"
                  name="password2"
                  dependencies={["password"]}
                  rules={[
                    {
                      required: true,
                      message: "Bitte bestätigen Sie das Passwort!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Die Passwörter stimmen nicht überein!")
                        );
                      },
                    }),
                  ]}
                >
                  <Input
                    type="password"
                    placeholder="Passwort bestätigen"
                    prefix={<LockOutlined />}
                    required
                    allowClear={false}
                    disabled={false}
                  ></Input>
                </Form.Item>
                <Form.Item>
                  <Button block type="primary" htmlType="submit">
                    Registrieren
                  </Button>
                </Form.Item>

                {errorMessage && (
                  <ResendConfirmEMailButton username={form.username} />
                )}
              </Form>
            </Card>
          </Space>
        </center>
        </Watermark>
      </div>
    </>
  );
};

export const RegisterUserModal = () => {
  const [modal2Open, setModal2Open] = useState(true);
  const navigate = useNavigate();
  return (
    <>
      <Modal
        title="Herzlich Willkommen"
        width={400}
        centered
        open={modal2Open}
        cancelText="Schließen"
        onCancel={() => {
          setModal2Open(false);
          navigate("/");
        }}
        onOk={() => setModal2Open(false)}
        okText="-"
        okButtonProps={{ style: { display: "none" } }} // Hier wird der OK-Button ausgeblendet
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <RegisterUser isModal={true} />
      </Modal>
    </>
  );
};
